import { motion } from "framer-motion";

const SectionWrapper = ({ children, className = "", id }) => {
  return (
    <motion.section
      id={id}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6 }}
      className={`section-padding ${className}`}
    >
      <div className="container-max">{children}</div>
    </motion.section>
  );
};

export default SectionWrapper;